import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map, shareReplay, take } from 'rxjs/operators';

@Component({
  selector: 'app-dialog-image-viewer',
  templateUrl: './dialog-image-viewer.component.html',
  styleUrls: ['./dialog-image-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogImageViewerComponent implements OnInit {

  images$ = new BehaviorSubject<string[]>([]);
  slideIndex$ = new BehaviorSubject(0);
  downloadURL$ = this.getDownloadURL();

  constructor(
    private dialogRef: MatDialogRef<DialogImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { src: string[], index?: number },
  ) { }

  ngOnInit(): void {
    if (this.data.index) {
      this.slideIndex$.next(this.data.index);
    }
    this.images$.next(this.data.src);
  }

  next() {
    const currentSlideIndex = this.slideIndex$.getValue();
    const newSlideIndex = currentSlideIndex + 1;
    if (newSlideIndex === this.data.src.length) {
      this.slideIndex$.next(0);
    } else {
      this.slideIndex$.next(newSlideIndex);
    }
  }

  prev() {
    const currentSlideIndex = this.slideIndex$.getValue();
    const newSlideIndex = currentSlideIndex - 1;
    if (newSlideIndex < 0) {
      this.slideIndex$.next(this.data.src.length - 1);
    } else {
      this.slideIndex$.next(newSlideIndex);
    }
  }

  delete() {
    const images = this.images$.getValue();
    const slideIndex = this.slideIndex$.getValue();
    this.dialogRef.close(images[slideIndex]);
  }

  download() {
    this.downloadURL$.pipe(
      take(1)
    ).subscribe(downloadURL => {
      // FileSaver.saveAs("https://httpbin.org/image", "image.jpg");
    });
  }

  private getDownloadURL(): Observable<string> {
    return combineLatest([
      this.images$,
      this.slideIndex$
    ]).pipe(
      map(([images, slideIndex]) => images[slideIndex]),
      shareReplay(1)
    );
  }

}
